<template>
	<div id="news">
		<div class="news_banner" v-cloak></div>
		<div class="news_lists">
			<div class="news_list" v-for="(item,index) in news_showBypage" @click="gotoUrl(item)">
				<img v-lazy="item.imageurl">
				<div class="news_listContent">
					<div class="news_listTitle">
						<div class="news_listTitleline"></div>
						<div class="news_listTitletext">{{item.title}}</div>
					</div>
					<div class="news_listDetail">{{item.abstract}}</div>
				</div>
				<div class="news_date">
					<div class="news_date_year">{{item.date_year}}</div>
					<div class="news_date_month_day">{{item.date_month_day}}</div>
				</div>
			</div>
		</div>
		<div class="news_page">
			<div v-for="n in pagecount" :class="n==pageIndex?'news_pageSelect':''" @click="goPage(n)">{{n}}</div>
			<div class="news_pageNext" @click="goNextPage"></div>
		</div>
	</div>
</template>

<script>
	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'renderer',
						content: 'http://www.ax168.com/news'
					},
					{
						name: 'news',
						content: '新闻资讯。'
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
				news: [],
				pagecount: 0,
				page_now: 1,
				news_showBypage: [],
				pageIndex: 1,
				pagec: 8,
				
			}
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		created() {
			this.getNewsList()
		},
		mounted: function() {
			
			// this.pageJump();
		},
		methods: {
			// 点击新闻跳转页面
			gotoUrl: function(item) {
				if(item.newstype == '1') {
					// this.$router.push({
					// 	path: '/newsDetail',
					// 	query: {
					// 		id: item.id
					// 	}
					// });
					const routeUrl = this.$router.resolve({
					    path: '/newsDetail',
					    query: { 
							id: item.id
						}
					})
					window.open(routeUrl.href, '_blank')
				} else {
					window.open(item.jumpurl);
				}
			},
			// 跳转页码
			pageJump: function() {
				this.news_showBypage = [];
				for(var i = (this.page_now - 1) * 8; i < this.page_now * 8; i++) {
					if(this.news[i] != null) {
						this.news_showBypage.push(this.news[i])
					}
				}
			},
			// 选中页码
			goPage: function(page) {
				this.pageIndex = page; //页码变选中样式		
				document.documentElement.scrollTop = 450;
				this.getNewsList()
			},
			// 跳转到下一页
			goNextPage: function() {
				this.pageIndex = this.pageIndex + 1;
				if(this.pageIndex*this.pagec > this.pagecount) {
					this.$parent.toast('已经到最后一页')
				} else {
					this.goPage(nextPage);
				}
			},
			getNewsList() {
				let th = this;
				let link = this.GLOBAL.serviceaddress + 'news/getNewsinfoList.do'
				$.ajax({
					method: 'post',
					url: link,
					data: {
						pageIndex: th.pageIndex,
						pagec: th.pagec,
						name: ''
					},
					headers: {
						token: 'xjVd7a.mC6DEqXkIKxMh8jIEMvTFXtiI'
						// token: ''
					}
				}).then(res => {
					if(res.resultCode == '000000') {
						this.news_showBypage = res.body;
						this.news_showBypage.forEach(item => {
							var date = item.newstime;
							var date_year = date.substr(0, 4);
							var date_month_day = date.substr(5, 5);
							item.date_year = date_year;
							item.date_month_day = date_month_day;
							console.log(date_year);
							console.log(date_month_day);
						})
						// for(var i = 0; i < this.news.length; i++) {
						// 	// 分割新闻的时间为 年，月日
							
						// }
						this.pagecount = Math.ceil(res.body[0].count / th.pagec);
						console.log(this.pagecount);
					}
				})
			}
		},
		
	}
</script>

<style>
	@import url('../css/news.css');
	[v-cloak] {
		display: none !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/news.vue